import { connect } from 'react-redux';
import { logOut } from '@zippeditoolsjs/heimdal-react';
import MissingCredentialsModal from '../../../components/profile/dialogs/MissingCredentialsModal';
import { userProfile } from 'core/selectors';

export default connect(
  state => ({
    userProfile: userProfile(state),
  }),
  { logOut },
)(MissingCredentialsModal);
